import { gql } from '@apollo/client'

export const Query = gql`
  query EditEventStage($companyId: ID!, $eventId: ID!, $eventStageId: ID!) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventStages(filters: { idEq: $eventStageId }, first: 1) {
          nodes {
            id
            name
            notes
          }
        }
      }
    }
  }
`
